import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Dispersion } from '../models/dispersions';
import { environment } from './../../../environments/environment';
import { HttpApiService } from './http/http-api.service';
import { HttpRequestMethod } from './http/request-methods';

@Injectable({
  providedIn: 'root'
})
export class DispersionsService {
  domain = '/api/dispersions/';
  dispersionCollection: AngularFirestoreCollection<Dispersion>;
  dispersionDoc: AngularFirestoreDocument<Dispersion>;
  dispersions: Observable<Dispersion[]>;
  dispersion: Observable<Dispersion>;

  constructor(
    private afs: AngularFirestore,
    private http: HttpClient,
    private httpApiService: HttpApiService
  ) {
    this.dispersionCollection = this.afs.collection('dispersions', (ref) =>
      ref.orderBy('dateScheduled', 'desc')
    );
  }

  /** 
   * Autor: Rene Carmona
   * Fecha: Martes 12 Enero del 2021
   * Descripcion: Obtener las dispersiones de todas las compañias
  */
  getAllDispersions() { 
    return this.http.get(environment.api + this.domain);
  }
  /** 
   * Autor: Rene Carmona
   * Fecha: Martes 12 Enero del 2021
   * Descripcion: Obtener las dispersiones de una compañia 
   * Parametros 
   *  - companyId (string)
  */
  getDispersionsCompany(_companyId) {
    return this.http.post(environment.api + this.domain + 'company', {
      companyId: _companyId
    });
  }
  getCompanyDispersions(id: string): Observable<Dispersion[]> {
    const diespersionsObj: any = this.afs.collection('dispersions', ref => ref.where('companyId', '==', id)).valueChanges();
    return diespersionsObj;
  }
  getDispersions(): Observable<Dispersion[]> {
    // Get items with the id
    this.dispersions = this.dispersionCollection.snapshotChanges().pipe(
      map((changes) => {
        return changes.map((action) => {
          const data = action.payload.doc.data() as Dispersion;
          data.id = action.payload.doc.id;
          return data;
        });
      })
    );
    return this.dispersions;
  }
  getDispersionsWhereStatusIgualMenor3(): Observable<Dispersion[]> {
    // Get items with the id
    this.dispersions = this.afs.collection('dispersions', (ref) =>
        ref.where('status','<=',3) //.orderBy('dateScheduled', 'desc')
    ).snapshotChanges().pipe(
      map((changes) => {
        return changes.map((action) => {
          const data = action.payload.doc.data() as Dispersion;
          data.id = action.payload.doc.id;
          return data;
        });
      })
    );
    return this.dispersions;
  }
  getDispersion(id: string): Observable<Dispersion> {
    this.dispersionDoc = this.afs.doc<Dispersion>(`dispersions/${id}`);
    this.dispersion = this.dispersionDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as Dispersion;
          data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.dispersion;
  }

  newDispersion(dispersion: Dispersion): Promise<{ dispersion: Dispersion } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewDispersion = await this.dispersionCollection.add(
          JSON.parse(JSON.stringify(dispersion))
        );
        resolve(savingNewDispersion.id);
        const myObj: any = {};
        myObj.id = savingNewDispersion.id;
        this.updateDispersion(myObj.id, myObj);
      } catch (err) {
        reject(err);
      }
    });
  }

  sendNotificationNewDispersion(dispersion: Dispersion){
    return this.httpApiService.apiNode<any>(HttpRequestMethod.POST,`email/sendNotificationNewDispersion`,dispersion);
  }
  async updateDispersion(
    docId: string,
    newData: any
  ): Promise<{ dispersion: Dispersion } | any> {
    try {
      let response = await this.afs.doc(`dispersions/${docId}`).update(newData);
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  async deleteDispersion(idDispersion) {
    try{
      let response = await this.afs.doc(`dispersions/${idDispersion}`).delete();
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  getDispersionsByUser(uid: string, dateStart?, dateEnd?) {
    return this.http.post(environment.api + this.domain + 'user', {
      userId: uid,
      dateStart: dateStart,
      dateEnd: dateEnd
    });
  }
  /***********************  Dispersions Partials  ******************************/
  getDispersionsPartials() {
    return this.http.post(environment.api + this.domain + 'partials', {});
  }
  
}
